import HTTPClient from './http-client';
import { createUrl } from "../utils_functions";
const END_POINT = '/operationsensorstation';

const options = {
  cache: {
    maxAge: 15 * 60 * 1000,
    exclude: { query: false }
  }
}

const loadOperationSensorStation = async ({ operation_ids, organization_ids, sensor_ids, station_ids, stationtype_ids, summary_operation }) => {
  const httpClient = new HTTPClient();
  const api = await httpClient.configure();
  const url = createUrl(END_POINT, { operation_ids, organization_ids, sensor_ids, station_ids, stationtype_ids, summary_operation });
  return api.get(url, options);
}

export {
  loadOperationSensorStation,
}
